/**
 * 创作者中心 左侧导航
 * @returns
 */
import {
  Box,
  Button,
  Flex,
  Icon,
  IconButton,
  Tooltip,
  Text,
  useDisclosure,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Image,
  Center,
  VStack,
  useToast,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuGroup,
} from "@chakra-ui/react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  RiHomeLine,
  RiBillLine,
  RiLineChartLine,
  RiCopperCoinLine,
  RiBookOpenLine
} from "@remixicon/react";

import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { selectUser } from "@/reducer/userslice";

import NavMenu from "./navmenu";
import { NavMenuItem } from "@/types/creatorcenter";

const CreatorNavLeft = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const currentUrl = location.pathname;
  const toast = useToast();
  const user = useAppSelector(selectUser);

  const testMenuList: NavMenuItem[] = [
    {
      title: "我的模型",
      icon: <RiHomeLine size="16px"></RiHomeLine>,
      path: "/creatorcenter/mymodels"
    },
    // {
    //   title: "首页",
    //   icon: <RiHomeLine size="16px"></RiHomeLine>,
    //   path: "/creatorcenter"
    // },
    // {
    //   title: "内容管理",
    //   icon: <RiBillLine size="16px"></RiBillLine>,
    //   subMenu: [
    //     { title: "我的AI创作", path: "/creatorcenter/aiworks" },
    //     { title: "我的模型", path: "/creatorcenter/mymodels" },
    //   ],
    // },
    // {
    //   title: "数据中心",
    //   icon: <RiLineChartLine size="16px"></RiLineChartLine>,
    //   path: "/creatorcenter/datacenter"
    // },
    // {
    //   title: "变现中心",
    //   icon: <RiCopperCoinLine size="16px"></RiCopperCoinLine>,
    //   path: "/creatorcenter/realization"
    // },
    // {
    //   title: "创作学院",
    //   icon: <RiBookOpenLine size="16px"></RiBookOpenLine>,
    //   path: "/creatorcenter/schoolofcreativity"
    // },
  ];

  return (
    <Box>
      <NavMenu MenuList={testMenuList} />
    </Box>
  );
};

export default CreatorNavLeft;
